import { useStores } from 'src/contexts/stores';
import InstoreCart from 'src/payments/state/instore-cart';

export default function useInstoreCart(): InstoreCart {
  const stores = useStores();

  return stores.InstoreCart;
}
